"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EWorkspace = void 0;
const EnumObject_1 = require("../../../../core/domain/EnumObject");
const enumValues = {
    PUBLIC: "PUBLIC",
    ORG: "ORG",
    USER: "USER",
};
class EWorkspace extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static fromUserId(userId) {
        if (![EWorkspace.V.ORG, EWorkspace.V.PUBLIC].includes(userId.toUpperCase()))
            return EWorkspace.V.USER;
        return userId.toUpperCase();
    }
    static userIdOrWorkspace(workspaceId, userId) {
        return workspaceId.toUpperCase() === EWorkspace.V.USER ? userId : workspaceId.toUpperCase();
    }
    static userIdOrWorkspaceV2(userId) {
        var _a, _b;
        if (((_a = userId === null || userId === void 0 ? void 0 : userId.toUpperCase) === null || _a === void 0 ? void 0 : _a.call(userId)) === EWorkspace.V.ORG || ((_b = userId === null || userId === void 0 ? void 0 : userId.toUpperCase) === null || _b === void 0 ? void 0 : _b.call(userId)) === EWorkspace.V.PUBLIC)
            return userId.toUpperCase();
        return userId;
    }
    static isShared(value) {
        if (!value)
            return false;
        return [EWorkspace.V.ORG, EWorkspace.V.PUBLIC].includes(value.toUpperCase());
    }
    static isUserOrOrg(value) {
        if (!value)
            return false;
        const convertedValue = this.fromUserId(value);
        return [EWorkspace.V.ORG, EWorkspace.V.USER].includes(convertedValue);
    }
    static create(p) {
        return new EWorkspace(p);
    }
}
exports.EWorkspace = EWorkspace;
EWorkspace.V = enumValues;
//# sourceMappingURL=EWorkspace.js.map